// Create this file at: src/pages/procesos/registrar/components/DeudasForm/utils/currency.js

export const formatCurrency = (value) => {
  if (!value) return { formatted: "$ 0", value: 0 };

  const number = value.toString().replace(/\D/g, "");
  const numberValue = Number(number);
  const formatter = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return {
    formatted: formatter.format(number || 0),
    value: numberValue,
  };
};
